import { useQuery } from "@tanstack/react-query";
import { getTicketPriorities } from "../../api/TICKET/ticketMeta";

export const useTicketPriorities = () =>
  useQuery({
    queryKey: ["ticket-priorities"],
    queryFn: getTicketPriorities,
    staleTime: 4 * 60 * 60 * 1000,
  });
